var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 5.14706H16.6668M7.50016 2.5H12.5002M8.3335 13.9706V8.67647M11.6668 13.9706V8.67647M12.9168 17.5H7.0835C6.16302 17.5 5.41683 16.7099 5.41683 15.7353L5.03633 6.06614C5.0166 5.56486 5.39509 5.14706 5.86894 5.14706H14.1314C14.6052 5.14706 14.9837 5.56486 14.964 6.06614L14.5835 15.7353C14.5835 16.7099 13.8373 17.5 12.9168 17.5Z",
    stroke: "#2D2B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash01);
export default __webpack_public_path__ + "static/media/trash-01.5e60756e9b63b736a4f6e3a3451aada9.svg";
export { ForwardRef as ReactComponent };